module.exports = __webpack_public_path__ + "8523b07df19413851f0dee00a8909e6a.png";